import axios from 'axios'
import { ApiResponse, AsessFilterDto } from '../models/Base'
import { TableDto } from '../models/dto/SelfAssessment'
import { StatAssessDto, StatAssessRequestDto } from '../models/dto/Stat'
 
const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/stat-assesses`


export function GetById(payload: number) {
    return axios.get<ApiResponse<StatAssessDto>>(`${ACTION_API_URL}/${payload}`)
}

export function Search(payload: AsessFilterDto) {
    return axios.post<ApiResponse<TableDto>>(`${ACTION_API_URL}/search`, payload)
}

export function Create(payload: StatAssessRequestDto) {
    return axios.post(`${ACTION_API_URL}`, payload)
}

export function Update(id: number, payload: StatAssessRequestDto) {
    return axios.put(`${ACTION_API_URL}/${id}`, payload)
}
